import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';

const Title = ({ title, titleUrl, isRailAdjacent }) => {
  if (!title) {
    return null;
  }
  return (
    <h2
      className={classNames(
        'cover-spread__headline',
        { 'cover-spread__rail': isRailAdjacent },
      )}
      data-test="cover-spread__headline"
    >
      {titleUrl ? (
        <Link href={titleUrl}>
          {title}
        </Link>
      ) : title}
    </h2>
  );
};

Title.propTypes = {
  isRailAdjacent: PropTypes.bool,
  title: PropTypes.string,
  titleUrl: PropTypes.string,
};

Title.defaultProps = {
  isRailAdjacent: false,
  title: null,
  titleUrl: null,
};

export { Title };
